// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
export const PATIENT_REVOKE_REQUEST = `PATIENT_REVOKE_REQUEST`;
export const PATIENT_REVOKE_SUCCESS = `PATIENT_REVOKE_SUCCESS`;
export const PATIENT_REVOKE_FAILURE = `PATIENT_REVOKE_FAILURE`;

// ET - Early Termination
export const PATIENT_ET_REQUEST = `PATIENT_ET_REQUEST`;
export const PATIENT_ET_SUCCESS = `PATIENT_ET_SUCCESS`;
export const PATIENT_ET_FAILURE = `PATIENT_ET_FAILURE`;



// WEBPACK FOOTER //
// ./src/views/state/IdtfRevokeET/types.js